import React from "react";
import { useDispatch } from "react-redux";
import {
  onCatalogSubmit,
  onCreateCatalogUpdate,
} from "../../../redux/homeAction";
import { useNavigate } from "react-router-dom";

const BottomHeader = ({ catalogId, products, setLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const buildProductPayload = (products) => {
    return products.map((p) => ({
      ...p,

      images: [
        {
          type: "front",
          url: p.images?.find((i) => i.type === "front")?.url || "",
        },
        {
          type: "side",
          url: p.images?.find((i) => i.type === "side")?.url || "",
        },
        {
          type: "back",
          url: p.images?.find((i) => i.type === "back")?.url || "",
        },
        {
          type: "zoom",
          url: p.images?.find((i) => i.type === "zoom")?.url || "",
        },
        ...(p.images || [])
          .filter((i) => i.type === "extra")
          .map((i) => ({
            type: "extra",
            url: i.url,
          })),
      ],

      sizes: (p.sizes || []).map((val) => ({
        size: val.size,
        mrp: Number(val.mrp || 0),
        price: Number(val.price || 0),
        inventory: Number(val.inventory || 0),
        sku: val.sku || "",
        bust: val.bust || "",
        shoulder: val.shoulder || "",
        waist: val.waist || "",
        length: val.length || "",
        hip: val.hip || "",
      })),
    }));
  };

  const saveDraft = async () => {
    const formData = new FormData();
    const payload = buildProductPayload(products);
    formData.append("products", JSON.stringify(payload));

    products.forEach((p, i) => {
      Object.values(p.images || {}).forEach((img) => {
        if (img?.file) {
          formData.append(`images_${i}`, img.file);
        }
      });
    });

    dispatch(onCreateCatalogUpdate(catalogId, formData, setLoading));
  };

  const validateProducts = () => {
    for (let index = 0; index < products.length; index++) {
      const p = products[index];
      const prodNum = index + 1;

      // 1. Product, Size and Inventory & Basic Fields Check
      if (!p.weight) {
        alert(`Product #${prodNum}: Net Weight is required.`);
        return false;
      }
      if (!p.name) {
        alert(`Product #${prodNum}: Product Name is required.`);
        return false;
      }
      if (!p.selectedSizes || p.selectedSizes.length === 0) {
        alert(`Product #${prodNum}: Please select at least one Size.`);
        return false;
      }

      // 2. Size Matrix Check (Har selected size ke liye values required hain)
      if (!p.sizes || p.sizes.length !== p.selectedSizes.length) {
        alert(`Product #${prodNum}: Size Matrix details are incomplete.`);
        return false;
      }
      for (const sizeItem of p.sizes) {
        if (
          !sizeItem.mrp ||
          !sizeItem.price ||
          sizeItem.inventory === undefined ||
          !sizeItem.sku
        ) {
          alert(
            `Product #${prodNum}: All fields (MRP, Price, Inventory, SKU) in Size Matrix are required for size ${sizeItem.size}.`,
          );
          return false;
        }
      }

      // 3. Product Details Check (Fabric, Manufacturer info, etc.)
      if (!p.fabric) {
        alert(`Product #${prodNum}: Fabric is required.`);
        return false;
      }
      // if (!p.manufacturerName) {
      //   alert(`Product #${prodNum}: Manufacturer Name is required.`);
      //   return false;
      // }
      // if (!p.manufacturerAddress) {
      //   alert(`Product #${prodNum}: Manufacturer Address is required.`);
      //   return false;
      // }
      // if (!p.manufacturerPincode) {
      //   alert(`Product #${prodNum}: Manufacturer Pincode is required.`);
      //   return false;
      // }

      // 4. Model & Product Extra Info Check
      if (!p.gender) {
        alert(`Product #${prodNum}: Gender is required.`);
        return false;
      }
      if (!p.garmentType) {
        alert(`Product #${prodNum}: Garment Type is required.`);
        return false;
      }
      if (!p.fitType) {
        alert(`Product #${prodNum}: Fit Type is required.`);
        return false;
      }

      // 5. Set / Combo Info Check
      if (p.isSet === undefined || p.isSet === null) {
        alert(`Product #${prodNum}: Product Type (Single or Set) is required.`);
        return false;
      }
      if (p.isSet) {
        if (!p.setItemsCount) {
          alert(
            `Product #${prodNum}: Set Items Count is required for combo products.`,
          );
          return false;
        }
        if (!p.includedItems || p.includedItems.length === 0) {
          alert(
            `Product #${prodNum}: Included Items are required for combo products.`,
          );
          return false;
        }
      }

      // 6. Return & Refund Policy Check
      if (p.returnAllowed && !p.returnDays) {
        alert(
          `Product #${prodNum}: Return Days are required when return is allowed.`,
        );
        return false;
      }
      if (p.exchangeAllowed && !p.exchangeDays) {
        alert(
          `Product #${prodNum}: Exchange Days are required when exchange is allowed.`,
        );
        return false;
      }

      // 7. Other Attributes Check
      if (!p.sleeveStyling) {
        alert(`Product #${prodNum}: Sleeve Styling is required.`);
        return false;
      }
      if (!p.description) {
        alert(`Product #${prodNum}: Description is required.`);
        return false;
      }
    }
    return true;
  };

  const submitDraft = async () => {
    // Pehle saari mandatory fields validate honi chahiye
    if (!validateProducts()) {
      return;
    }

    // Agar validation pass ho jaye, toh pehle draft save/update karein phir submit karein
    await saveDraft();
    dispatch(onCatalogSubmit(catalogId, setLoading, navigate));
  };

  return (
    <>
      <div className="fixed bottom-0 left-0 w-full bg-white border-t p-3 flex justify-end gap-3 z-50">
        <button className="px-4 py-2 border rounded" onClick={saveDraft}>
          Save Draft
        </button>

        <button
          className="px-4 py-2 bg-indigo-600 text-white rounded"
          onClick={submitDraft}
        >
          Submit Catalog
        </button>
      </div>
    </>
  );
};

export default BottomHeader;
